import { tokens } from "shared/components/Spor";

import { Grey, WhiteAlpha } from "shared/theme/sidespor/types";
import { appPalette } from "shared/theme/sidespor/theme/appPalette";
import { mapValues } from "shared/utils/arrayUtils";

const { palette } = tokens.default.color;
const alias = mapValues(tokens.default.color.alias, (value) => {
  const [_, color, strength] = value.split(".");
  const paletteColor = (palette as any)[color];
  // Some aliases reference a single value (e.g. "colors.white") with no strength.
  return strength ? paletteColor[strength] : paletteColor;
});

const colors: Record<string, string | WhiteAlpha | Grey> = {
  ...appPalette,
  ...palette,
  ...alias,
};

export default colors;
